export const parseTrailData = (data) => {
  const newTrailCoords = [];
  for (let i = 0; i < data.features.length; i++) {
    const feature = data.features[i];
    let pathPoint = feature.geometry.paths[0];

    // make sure its longer that 1 point
    if (pathPoint[1] !== undefined) {
      pathPoint = pathPoint[1];
    } else {
      pathPoint = pathPoint[0];
    }

    const trailCoord = {
      attributes: feature.attributes,
      polyline: feature.geometry.paths.flat(),
      geometry: feature.geometry, // Preserve original geometry for multi-segment trails
      lat: pathPoint[1],
      lng: pathPoint[0],
    };
    newTrailCoords.push(trailCoord);
  }
  return newTrailCoords;
};
